import { isArray, mergeWith, merge } from "lodash";
import {
  CREATE_TRANSACTIONNOTE_REQUEST,
  CREATE_TRANSACTIONNOTE_SUCCESS,
  CREATE_TRANSACTIONNOTE_FAILURE
} from "../types";

function customizer(objValue, srcValue) {
  if (isArray(objValue)) {
    return objValue.concat(srcValue);
  }
}

export default (state, action) => {
  switch (action.type) {
    case CREATE_TRANSACTIONNOTE_REQUEST:
      return {
        ...state,
        loadingTransactionNotes: true
      };
    case CREATE_TRANSACTIONNOTE_SUCCESS:
      return {
        ...state,
        loadingTransactionNotes: false,
        transactionNotes: mergeWith(
          merge({}, action.payload),
          state.transactionNotes,
          customizer
        )
      };
    case CREATE_TRANSACTIONNOTE_FAILURE:
      return {
        ...state,
        loadingTransactionNotes: false
      };
    default:
      return state;
  }
};
